import React, { useState, createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const questionSearchContext = createContext();

export const QuestionSearchProvider = ({ children }) => {
  const [primaryCourseFilters, setPrimaryCourseFilters] = useState([]);
  const [questionsTabBasicGradeIds, setQuestionsTabBasicGradeIds] = useState([]);
  const [questionsTabBasicCourse, setQuestionsTabBasicCourse] = useState([]);
  const [questionsTabAdvSelectedCourseIds, setQuestionsTabAdvSelectedCourseIds] = useState([]);
  const [questionsTabAdvMathCourses, setQuestionsTabAdvMathCourses] = useState([]);
  const [questionsTabAdvSocialStudiesCourses, setQuestionsTabAdvSocialStudiesCourses] = useState([]);
  const [questionsTabAdvScienceCourses, setQuestionsTabAdvScienceCourses] = useState([]);
  const [questionsTabAdvEnglishCourses, setQuestionsTabAdvEnglishCourses] = useState([]);
  const [questionsTabAdvForeignLangCourses, setQuestionsTabAdvForeignLangCourses] = useState([]);
  const [questionsTabAdvOtherCourses, setQuestionsTabAdvOtherCourses] = useState([]);
  const [examsTabSelectedGrades, setExamsTabSelectedGrades] = useState([]);
  const [examsTabSelectedCourses, setExamsTabSelectedCourses] = useState([]);
  const [examsTabSelectedStates, setExamsTabSelectedStates] = useState([]);
  const [examsTabSelectedExamYears, setExamsTabSelectedExamYears] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  const [courseFilters, setCourseFilters] = useState([]);
  const [standardFilters, setStandardFilters] = useState([]);
  const [standardFiltersApplied, setStandardFiltersApplied] = useState(false);
  const [questionTypeFilters, setQuestionTypeFilters] = useState([]);
  const [contentAreaFilters, setContentAreaFilters] = useState([]);
  const [levelFilters, setLevelFilters] = useState([]);
  const [topicFiltersApplied, setTopicFiltersApplied] = useState(false);
  const [topicFilters, setTopicFilters] = useState([]);
  const [showClassicCourses, setShowClassicCourses] = useState(false);
  const [showClassicCoursesToggle, setShowClassicCoursesToggle] = useState(true);
  const [translationFilters, setTranslationFilters] = useState([]);
  const [personalAssignmentFilters, setPersonalAssignmentFilters] = useState([]);
  const [teacherContentSetsFilter, setTeacherContentSetsFilter] = useState([]);
  const [publicAssignmentFilters, setPublicAssignmentFilters] = useState([]);
  const [tagFilters, setTagFilters] = useState([]);
  const [attributeFilters, setAttributeFilters] = useState([]);
  const [questionSourceFilters, setQuestionSourceFilters] = useState([]);
  const [resetQuestions, setResetQuestions] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [activityName, setActivityName] = useState('');

  const gradeFilterOptions = [
    {
      id: 1,
      name: 'K',
      gradeId: [0],
      isChecked: false
    },
    {
      id: 2,
      name: '1',
      gradeId: [1],
      isChecked: false
    },
    {
      id: 3,
      name: '2',
      gradeId: [2],
      isChecked: false
    },
    {
      id: 4,
      name: '3',
      gradeId: [3],
      isChecked: false
    },
    {
      id: 5,
      name: '4',
      gradeId: [4],
      isChecked: false
    },
    {
      id: 6,
      name: '5',
      gradeId: [5],
      isChecked: false
    },
    {
      id: 7,
      name: '6',
      gradeId: [6],
      isChecked: false
    },
    {
      id: 8,
      name: '7',
      gradeId: [7],
      isChecked: false
    },
    {
      id: 9,
      name: '8',
      gradeId: [8],
      isChecked: false
    },
    {
      id: 10,
      name: '9-12',
      gradeId: [9,10,11,12],
      isChecked: false
    }
  ];

  return (
    <questionSearchContext.Provider
      value={{
        primaryCourseFilters,
        setPrimaryCourseFilters,
        questionsTabBasicGradeIds,
        setQuestionsTabBasicGradeIds,
        questionsTabBasicCourse,
        setQuestionsTabBasicCourse,
        questionsTabAdvSelectedCourseIds,
        setQuestionsTabAdvSelectedCourseIds,
        questionsTabAdvMathCourses,
        setQuestionsTabAdvMathCourses,
        questionsTabAdvSocialStudiesCourses,
        setQuestionsTabAdvSocialStudiesCourses,
        questionsTabAdvScienceCourses,
        setQuestionsTabAdvScienceCourses,
        questionsTabAdvEnglishCourses,
        setQuestionsTabAdvEnglishCourses,
        questionsTabAdvForeignLangCourses,
        setQuestionsTabAdvForeignLangCourses,
        questionsTabAdvOtherCourses,
        setQuestionsTabAdvOtherCourses,
        examsTabSelectedGrades,
        setExamsTabSelectedGrades,
        examsTabSelectedCourses,
        setExamsTabSelectedCourses,
        examsTabSelectedStates,
        setExamsTabSelectedStates,
        examsTabSelectedExamYears,
        setExamsTabSelectedExamYears,
        gradeFilterOptions,
        isSearching,
        setIsSearching,

        courseFilters,
        setCourseFilters,
        standardFilters,
        setStandardFilters,
        standardFiltersApplied,
        setStandardFiltersApplied,
        questionTypeFilters,
        setQuestionTypeFilters,
        contentAreaFilters,
        setContentAreaFilters,
        levelFilters,
        setLevelFilters,
        topicFilters,
        setTopicFilters,
        translationFilters,
        setTranslationFilters,
        personalAssignmentFilters,
        setPersonalAssignmentFilters,
        teacherContentSetsFilter,
        setTeacherContentSetsFilter,
        publicAssignmentFilters,
        setPublicAssignmentFilters,
        tagFilters,
        setTagFilters,
        attributeFilters,
        setAttributeFilters,
        questionSourceFilters,
        setQuestionSourceFilters,
        topicFiltersApplied,
        setTopicFiltersApplied,
        showClassicCourses, 
        setShowClassicCourses,
        showClassicCoursesToggle, 
        setShowClassicCoursesToggle,
        resetQuestions,
        setResetQuestions,
        showResults,
        setShowResults,
        activityName,
        setActivityName
      }}>
      {children}
    </questionSearchContext.Provider>
  );
};

QuestionSearchProvider.propTypes = {
  children: PropTypes.node
};

export const useQuestionSearchContext = () => useContext(questionSearchContext);
